import { Component, Input, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IPopupInfo, ISurveyAnswer } from '@maplix/utils';
import { uniqBy } from 'lodash';
import { DestroyComponent } from '@maplix/ng-utils';

@Component({
  selector: 'maplix-map-popup',
  templateUrl: './map-popup.component.html',
  styleUrls: ['./map-popup.component.scss'],
})
export class MapPopupComponent extends DestroyComponent implements OnChanges {
  @Input()
  public readonly popupInfo: IPopupInfo;

  @Input()
  public readonly mapId: string;

  public loadedImages: string[] = [];

  public language: string;

  constructor(private translate: TranslateService) {
    super();
  }

  ngOnChanges() {
    this.language = this.translate.currentLang;
  }

  public isLink(property: string) {
    return typeof property === 'string' && (property.includes('http://') || property.includes('https://'));
  }

  public translateTransportMode(mode: string) {
    return this.translate.instant('map.transportmodi.' + mode);
  }

  public getKeys(obj: any): string[] {
    return Object.keys(obj).filter((key) => key !== 'geometry');
  }

  public onOpenImage(url: string) {
    window.open(url, '_blank');
  }

  public getSubquestions(answers: ISurveyAnswer[]): { id: string; label: string }[] {
    const subquestions = answers
      .filter((a) => a.subquestion)
      .map((a) => {
        return {
          id: a.subquestion,
          label: a.subquestion_label,
        };
      });

    return uniqBy(subquestions, 'id');
  }
}
